import {
  faExclamationTriangle,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { Button } from 'semantic-ui-react'
import * as Config from '../../../public/external-links'
import Accordion from '../../common/Accordion'
import GreyBox from '../../common/GreyBox'
import { ICallout } from '../../../models/Callout'
import useCallout from '../../../hooks/useCallout'
import LoaderContext from '../../context/FormLoader'
import Conditional from '../../common/Conditional'
import CalloutDisplay from '../../common/CalloutDisplay'
import DocumentLink from '../../common/DocumentLink'

export const RequestForRecordsHeader = (props) => {
  const mountedRef = useRef(false)
  const [data, setData] = useState<ICallout[]>([])
  const [getCallout] = useCallout('RequestForRecordsTemplate', 'Before')
  const [isLoading, setIsLoading] = useState(true)
  const loader = useContext(LoaderContext)

  useEffect(() => {
    mountedRef.current = true
    loader.up()
    if (mountedRef.current) {
      getCallout()
        .then((response) => {
          if (mountedRef.current) {
            setData(response.callouts)
          }
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          setIsLoading(false)
          loader.down()
        })
    }
    return () => {
      mountedRef.current = false
    }
  }, [])
  return (
    <>
      <h1>Request for records</h1>
      <Accordion
        heading="Welcome to our Template Tool"
        expanded={props.show}
        onClick={() => props.setShow()}
      >
        <p> </p>
        <Conditional if={!isLoading}>
          {data &&
            data.map((c, i) => (
              <CalloutDisplay
                key={i}
                className=""
                content={c.content}
                name="RequestForRecords"
              />
            ))}
        </Conditional>
        <p></p>
        <p>
          This tool will help you prepare a request for records. Employees can
          request a copy of their employment records from a current or former
          employer.
        </p>
        <p>
          The tool will ask you simple questions and use your answers to tailor
          a letter for you. You will be able to save and edit your letter at the
          end.
        </p>
        <h2>Important information</h2>
        <p>
          Click the&nbsp;
          <FontAwesomeIcon
            className="ml-xs"
            icon={faExclamationTriangle}
            size={'1x'}
            color={'#da291c'}
          />
          &nbsp;buttons for important information about workplace rights and
          obligations
        </p>
        <h2>Get help</h2>
        <p>
          Click the&nbsp;
          <FontAwesomeIcon
            className="ml-xs"
            icon={faInfoCircle}
            size={'lg'}
            color={'#1b365d'}
          />
          &nbsp;buttons for explanations or help answering the question
        </p>
        <p>
          To protect your privacy none of the information you enter is stored in
          this tool or captured by the Fair Work Ombudsman.
        </p>

        <GreyBox>
          <p>
            <strong>Before you begin:</strong> To prepare your letter
            you&apos;ll need to know what records you will be requesting, the
            period these records will be for, and your preferred collection
            method.
          </p>
          <p>All fields are required unless marked optional.</p>
        </GreyBox>

        <Button className="ui is-primary button" onClick={props.handleStart}>
          Start
        </Button>
        <p>
          If you do not wish to use this tool, you can find an example request
          for records letter in our{' '}
          <DocumentLink
            name="Employee's guide to fixing workplace problems"
            urlDoc={Config.INTERACTIVE_TEMPLATE_REQUEST_FOR_RECORDS_DOCX}
            urlPdf={Config.INTERACTIVE_TEMPLATE_REQUEST_FOR_RECORDS_PDF}
          />
          .
        </p>
      </Accordion>
    </>
  )
}
